import { render, staticRenderFns } from "./YKIssuedFlowDetail.vue?vue&type=template&id=1f9fea50&scoped=true&"
import script from "./YKIssuedFlowDetail.vue?vue&type=script&lang=js&"
export * from "./YKIssuedFlowDetail.vue?vue&type=script&lang=js&"
import style0 from "./YKIssuedFlowDetail.vue?vue&type=style&index=0&id=1f9fea50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9fea50",
  null
  
)

export default component.exports